import React from "react";

import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import Api from "../../services/Api";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";
import { Switch } from "../Switch";
import { useSnackbar } from "../../hooks/useSnackbar";
import { Grid } from "../../UI/Grid";
import { TextField } from "../TextField";

interface IProps {
  subnetwork: number;
}

export const AddMatchingOptionModal: React.FC<IProps> = (props) => {
  const [matchingName, setMatchingName] = React.useState("");
  const [groupCanViewAll, setGroupCanViewAll] = React.useState(false);
  const [groupCanMatchAll, setGroupCanMatchAll] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setIsOpen } = useModalContext();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getAuthToken } = useAuth();

  const handleClose = () => setIsOpen(false);

  const handleAddGroup = React.useCallback(async () => {
    setIsLoading(true);

    const res = await Api.setGenderGroup(
      selectedNetworkId,
      {
        groupName: matchingName,
        groupCanViewAll,
        groupCanMatchAll,
        l1Id: selectedNetworkId,
        l2Id: props.subnetwork,
      },
      await getAuthToken()
    );

    if (res.success) {
      showSuccessSnackbar("Saved Changes");
    } else {
      showErrorSnackbar("An Error Occurred");
    }

    await loadNetworkInfoForNetworks([selectedNetworkId]);

    handleClose();
    setIsLoading(false);
  }, [
    selectedNetworkId,
    props.subnetwork,
    groupCanViewAll,
    groupCanMatchAll,
    matchingName,
  ]);

  const handlMatchingName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMatchingName((event.target as HTMLInputElement).value);
  };

  const handleMatchChange = (_: any, value: boolean) => {
    setGroupCanMatchAll(value);
  };

  const handleViewChange = (_: any, value: boolean) => {
    setGroupCanViewAll(value);
  };

  return (
    <Modal
      maxWidth="xs"
      title="Add Gender Group"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            appearance="primary"
            isLoading={isLoading}
            onClick={handleAddGroup}
          >
            Add Gender Group
          </Button>
        </>
      }
    >
      <Grid container spacing={2} px={3} py={2}>
        <Grid item xs={12}>
          <TextField
            label="Gender Group"
            value={matchingName}
            onChange={handlMatchingName}
          />
        </Grid>
        <Grid item xs={12}>
          <Switch
            label="Can Match With All"
            switchProps={{
              checked: groupCanMatchAll,
              onChange: handleMatchChange,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Switch
            label="Can View All"
            switchProps={{
              checked: groupCanViewAll,
              onChange: handleViewChange,
            }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};
